export const REDUX_STORE_HOME = 'article_activity'
